export const colors = {
  green: {
    100: '#D6E6E0',
    500: '#56C283'
  }
};
